import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { ReceivingFileModel, RequestParams, ResponseCatalog } from 'Models'
import { OutLinks } from 'Src/constants/OutLinks'
import {
	ProductModel,
	ExternalFormModel,
	ExternalFormShortInfoModel,
	dadataApiKey,
	DadataIpAddress,
	ParamsUrlType,
	markExternalFormModel,
	BuildFieldsModel,
	LeadCreate,
} from 'Pages/orders'
import { OrderModel } from 'Pages/orders_design'
import { Region } from 'Pages/landings/common/types'
import { SimpleResponse } from 'Types/simpleResponse'
import { FileWithPreview } from 'LibNeo'

export const externalFormsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ExternalFormModel>>(
			`${urls.orders.externalForm}`,
			{
				params,
			}
		)
		return res.data
	},
	getOne: async (token: string) => {
		const res = await axiosDS().get<ExternalFormModel>(`${urls.orders.externalForm}/${token}`)
		return res.data
	},
	createOne: async (data: ExternalFormShortInfoModel) => {
		const res = await axiosDS().post<ExternalFormModel>(`${urls.orders.externalForm}`, { data })
		return res.data
	},

	updateOne: async (data: ExternalFormShortInfoModel, id: string) => {
		const res = await axiosDS().patch<ExternalFormModel>(`${urls.orders.externalForm}/${id}`, {
			data,
		})
		return res.data
	},

	deleteOne: async (token: string) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.orders.externalForm}/${token}`)
		return res.data
	},

	restoreOne: async (token: string) => {
		const res = await axiosDS().patch<SimpleResponse>(
			`${urls.orders.externalForm}/${token}/restore`
		)
		return res.data
	},
	getOrderBuild: async (token: string, data: ParamsUrlType & { inn: string }) => {
		const res = await axiosDS().post<OrderModel>(
			`${urls.orders.externalForm}/${token}/order/build`,
			{
				data,
			}
		)
		return res.data
	},

	createOrder: async (token: string, data: any) => {
		const res = await axiosDS().post(`${urls.orders.externalForm}/${token}/order/`, { data })
		return res.data
	},

	sendPostback: async (clickId: string, trackId: string, partnerInn: string) => {
		const postBackUrl = OutLinks.postback[partnerInn]
			.replace(':click_id', clickId)
			.replace(':track_id', trackId)
		return axiosDS().get(postBackUrl)
	},
	getProducts: async (token: string) => {
		const res = await axiosDS().get<ProductModel[]>(
			`${urls.orders.externalForm}/${token}/order/products`
		)
		return res.data
	},
	markAdvExternalForm: async (data: markExternalFormModel, token: string) => {
		const res = await axiosDS().patch<ExternalFormModel>(
			`${urls.orders.externalForm}/${token}/mark_ad`,
			{ data }
		)
		return res.data
	},
	sendReport: async (params: RequestParams) => {
		const res = await axiosDS().get(`${urls.orders.report_external_forms}`, { params })
		return res.data
	},
	getRegions: async () => {
		const res = await axiosDS().get<ResponseCatalog<Region>>(urls.orders.regions)
		return res.data
	},
	getIp: async () => {
		const res = await axiosDS({ isExternal: true }).get<string>(OutLinks.getIp)
		return res.data
	},
	getDadataAddressByIp: async (ip: string) => {
		const urlData = OutLinks.daData.replace(':ip', ip)
		const responseConfig = {
			headers: {
				Authorization: `Token ${dadataApiKey}`,
			},
		}
		const res = await axiosDS({ isExternal: true }).get<DadataIpAddress>(urlData, responseConfig)
		return res.data
	},
	createInstruction: async (file: FileWithPreview | FileWithPreview[]) => {
		const data = new FormData()
		// @ts-ignore
		data.append('[instruction]', file)
		const res = await axiosDS().post(urls.orders.createInstruction, data)
		return res.data
	},
	getInstructionFile: async () => {
		const res = await axiosDS().get<ReceivingFileModel>(urls.orders.instructionUrl)
		return res.data
	},
	getWithInstructionFlag: async (params: { for_page: boolean }) => {
		const res = await axiosDS().get<{ with_instruction: boolean }>(urls.orders.instructionUrl, {
			params,
		})
		return res.data
	},
	getBuildFields: async (token: string, data: { product_ids: number[] }) => {
		const res = await axiosDS().post<BuildFieldsModel>(
			`${urls.orders.externalForm}/${token}/order/build_fields`,
			{
				data,
			}
		)
		return res.data
	},
	createLead: async (lead: LeadCreate) => {
		const res = await axiosDS().post<LeadCreate>(urls.orders.create_lead, {
			data: lead,
		})
		return res.data
	},
}
